<header
  id="header"
  class="{{
    scrollevent ? 'header fixed-top header-scrolled' : 'header fixed-top'
  }}"
>
  <div
    class="container-fluid container-xl d-flex align-items-center justify-content-between"
  >
    <a href="index.html" class="logo d-flex align-items-center">
      <span>S9</span>
    </a>

    <nav
      id="navbar"
      class="{{ mobileToggleEvent ? 'navbar navbar-mobile' : 'navbar' }}"
    >
      <ul>
        <li *ngIf="!profile">
          <a (click)="loginTransporter()">
            <img src="assets/img/gg_profile.svg" />Transporter Login</a
          >
        </li>
        <li>
          <!-- <a class="nav-link scrollto">
            <img src="assets/img/track.svg" /> Track</a
          > -->
        </li>
        <li *ngIf="loginSignup">
          <a class="getstarted scrollto" (click)="login('login')"
            >Customer Login</a
          >
        </li>
        <div class="dropdown" matTooltip="Profile" *ngIf="profile">
          <a mat-button [matMenuTriggerFor]="menu"
            ><img
              class="header-profile"
              src="{{ profilePic ? profilePic : 'assets/img/profilesimg.svg' }}"
            />Hi,
            <span style="text-transform: capitalize">{{ userName }}</span>
          </a>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="GoToProfile()">Profile</button>
            <div class="seperator"></div>
            <button mat-menu-item (click)="trips()">Trips</button>
            <div class="seperator"></div>
            <button mat-menu-item (click)="Logout()">Logout</button>
          </mat-menu>
        </div>
      </ul>
      <i
        class="{{
          mobileToggleEvent
            ? 'bi mobile-nav-toggle bi-x'
            : 'bi mobile-nav-toggle bi-list'
        }}"
        (click)="mobileToggle()"
      ></i>
    </nav>
    <!-- .navbar -->
  </div>
</header>
<section id="hero" class="hero d-flex align-items-center">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 d-flex flex-column justify-content-center">
        <h1 data-aos="fade-up">Redefining Trucking Experience</h1>
        <h2 data-aos="fade-up" data-aos-delay="400">
          One Stop for all your logistics needs.
        </h2>
        <div class="booking-area">
          <form [formGroup]="coordinatesForm">
            <div class="row booking-area-fields">
              <div class="input-fields">
                <mat-form-field
                  class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                  flex-gt-sm
                >
                  <span class="material-icons banner-icon">room</span>
                  <input
                    style="color: black; float: right"
                    formControlName="pickup"
                    (change)="onInputPickUpchange()"
                    #pickUpLocationSearchField
                    matInput
                    type="text"
                    placeholder="Pickup Area, City"
                    required
                  />
                  <span
                    class="material-icons close-icon"
                    *ngIf="showCloseIconPick"
                    (click)="clearPickField()"
                    >close</span
                  >
                </mat-form-field>
              </div>

              <div class="input-fields">
                <mat-form-field
                  class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                  flex-gt-sm
                >
                  <span class="material-icons banner-icon">room</span>
                  <input
                    (change)="onDropChange()"
                    style="color: black; float: right"
                    formControlName="drop"
                    #dropLocationSearchField
                    matInput
                    type="text"
                    placeholder="Drop Off Area, City"
                    required
                  />
                  <span
                    class="material-icons close-icon"
                    *ngIf="showCloseIconDrop"
                    (click)="clearDropField()"
                    >close</span
                  >
                </mat-form-field>
              </div>
              <div class="input-fields input-fields-two-items">
                <mat-form-field
                  class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                  flex-gt-sm
                >
                  <input
                    matInput
                    [matDatepicker]="picker1"
                    placeholder="Pickup Date"
                    [min]="minDate"
                    [max]="maxDate"
                    formControlName="date"
                    (click)="picker1.open()"
                    required
                  />
                  <mat-datepicker-toggle matSuffix [for]="picker1">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
                <mat-form-field
                  class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width truck-type-input"
                  flex-gt-sm
                >
                  <mat-select
                    dropLocationSearchField
                    placeholder="Truck Category"
                    formControlName="truck_category"
                    (selectionChange)="GetTruckWeight()"
                    required
                  >
                    <mat-option>Select Truck category</mat-option>
                    <mat-option
                      *ngFor="let cat of truckCategory"
                      value="{{ cat._id }}"
                      >{{ cat.truck_category_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- <div class="input-fields-last" *ngIf="user != 'corporate'">
                <mat-form-field
                  class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                  flex-gt-sm
                >
                  <mat-select
                    dropLocationSearchField
                    formControlName="truck_type"
                    required
                  >
                    <mat-option value="">Select Weight</mat-option>
                    <mat-option
                      *ngFor="let item of truckWeight"
                      value="{{ item._id }}"
                      >{{ item.truck_weight }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div> -->
            </div>
          </form>
          <div class="row p-0">
            <button class="sheer" (click)="requestQuote()">Search</button>
          </div>
        </div>
        <div data-aos="fade-up" data-aos-delay="600"></div>
      </div>
    </div>
  </div>
</section>
